import { render, staticRenderFns } from "./GroupStatisticsCard.vue?vue&type=template&id=1ab3197a&scoped=true&"
import script from "./GroupStatisticsCard.vue?vue&type=script&lang=js&"
export * from "./GroupStatisticsCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupStatisticsCard.vue?vue&type=style&index=0&id=1ab3197a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab3197a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
